import styled from 'styled-components';
import { COLORS } from 'assets/styled/colors';
import { marginSm, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${paddingMd};

  ${respondTo.bigPhone`
    padding: 15rem;
  `}
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${marginSm};
`;

export const Title = styled.div`
  font-size: 24rem;
  font-weight: 300;
  line-height: 36rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 20rem;
  `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10rem;
`;

export const TopContainer = styled.div``;

export const Margin = styled.div`
  margin-right: ${marginSm};
`;

export const Description = styled.div`
  font-size: 16rem;
  font-weight: 300;
  line-height: 21rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${COLORS.BLACK};
`;
